import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import "../../styles/footer.css";
import { getWhatsappUrl, siteConfig } from "../../utils/site";
import brandLogo from "../../assets/logo.png";

const quickLinks = [
  { path: "/about", display: "About Us" },
  { path: "/products", display: "Jewellery" },
  { path: "/designs", display: "Product Gallery" },
  { path: "/ai-gallery", display: "AI Gallery" },
  { path: "/course", display: "Roha Course" },
  { path: "/blogs", display: "Journal" },
  { path: "/design-request", display: "Bespoke Design" },
  { path: "/contact", display: "Contact Us" },
];

const legalLinks = [
  { path: "/terms", display: "Terms & Conditions" },
  { path: "/privacy", display: "Privacy Policy" },
];

const collections = [
  { path: "/products", display: "Ethiopian Opal Jewellery" },
  { path: "/products", display: "Emerald & Ruby Collection" },
  { path: "/products", display: "Habesha Gold Jewellery" },
  { path: "/products", display: "Bridal & Wedding" },
  { path: "/products", display: "Silver Jewellery" },
  { path: "/products", display: "Custom Bespoke Pieces" },
];

const Footer = () => {
  const year = new Date().getFullYear();
  const [email, setEmail] = useState("");

  const handleNewsletter = (e) => {
    e.preventDefault();
    setEmail("");
  };

  return (
    <footer className="roha-footer">

      {/* CTA Banner */}
      <div className="roha-footer__cta">
        <div>
          <p className="roha-footer__eyebrow">
            Ethiopia's Premier Luxury Jewellery House
          </p>

          <h2>
            Discover Gemstones Rooted in Ethiopian Heritage
          </h2>

          <p>
            From luminous Ethiopian opals to handcrafted Habesha gold —
            every Roha piece carries the soul of Africa's finest gemstone
            tradition. Shop online or visit our showroom in Addis Ababa.
          </p>
        </div>

        <div className="roha-footer__cta-actions">
          <Link
            to="/products"
            className="roha-footer__button roha-footer__button--solid"
          >
            Shop Collection
          </Link>

          <Link
            to="/design-request"
            className="roha-footer__button roha-footer__button--ghost"
          >
            Bespoke Design
          </Link>

          <a
            href={getWhatsappUrl(
              "Hello Roha Jewellery, I would like a private consultation."
            )}
            target="_blank"
            rel="noopener noreferrer"
            className="roha-footer__button roha-footer__button--ghost"
          >
            WhatsApp Us
          </a>
        </div>
      </div>

      <Container>
        <Row className="gy-5">

          {/* Brand */}
          <Col lg="4" md="12">
            <Link to="/" className="roha-footer__brand">
              <img
                src={brandLogo}
                alt="Roha Jewellery"
                className="roha-footer__brand-logo"
              />

              <span className="roha-footer__brand-copy">
                <strong>Roha Jewellery</strong>
                <small>Fine Ethiopian Gemstones</small>
              </span>
            </Link>

            <p className="roha-footer__logo-content">
              Ethiopia's trusted source for certified opal, emerald,
              ruby, sapphire, and handcrafted gold jewellery.
              Serving clients locally and internationally from our
              Addis Ababa showroom since 1994.
            </p>

            <div className="roha-footer__trust-grid">
              <span>Certified Gemstones</span>
              <span>Worldwide Delivery</span>
              <span>Bespoke Orders</span>
              <span>Secure Checkout</span>
            </div>

            <div
              className="roha-social__links"
              style={{ marginTop: "1.5rem" }}
            >
              <a
                href="https://facebook.com/rohajewellery"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-hover"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill"></i>
              </a>

              <a
                href="https://www.instagram.com/rohajewellery16/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-hover"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>

              <a
                href="https://www.tiktok.com/@rohajewellery16"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-hover"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line"></i>
              </a>

              <a
                href="https://t.me/roha_jewellery"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-hover"
                aria-label="Telegram"
              >
                <i className="ri-telegram-line"></i>
              </a>

              <a
                href="https://www.linkedin.com/company/roha-jewellery"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-hover"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line"></i>
              </a>

              <a
                href={getWhatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-hover"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line"></i>
              </a>

              <a
                href={`mailto:${siteConfig.email}`}
                className="social-icon-hover"
                aria-label="Email"
              >
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg="2" md="4" sm="6">
            <h5 className="roha-footer__link-title">
              Explore
            </h5>

            <div className="roha-footer__links">
              {quickLinks.map((item) => (
                <Link
                  key={item.path + item.display}
                  to={item.path}
                  className="footer-link-hover"
                >
                  {item.display}
                </Link>
              ))}
            </div>
          </Col>

          {/* Collections */}
          <Col lg="2" md="4" sm="6">
            <h5 className="roha-footer__link-title">
              Collections
            </h5>

            <div className="roha-footer__links">
              {collections.map((item) => (
                <Link
                  key={item.display}
                  to={item.path}
                  className="footer-link-hover"
                >
                  {item.display}
                </Link>
              ))}
            </div>
          </Col>

          {/* Contact */}
          <Col lg="4" md="4">
            <h5 className="roha-footer__link-title">
              Contact & Showroom
            </h5>

            <div className="roha-footer__contact">
              <p>
                <i className="ri-map-pin-2-line"></i>
                <span>{siteConfig.address}</span>
              </p>

              <p>
                <i className="ri-phone-line"></i>

                <span>
                  {siteConfig.phones.map((p, i) => (
                    <span key={p}>
                      <a
                        href={`tel:${p.replace(/\s/g, "")}`}
                        style={{
                          color: "inherit",
                          textDecoration: "none",
                        }}
                      >
                        {p}
                      </a>

                      {i < siteConfig.phones.length - 1 && <br />}
                    </span>
                  ))}
                </span>
              </p>

              <p>
                <i className="ri-mail-line"></i>

                <a
                  href={`mailto:${siteConfig.email}`}
                  style={{
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  {siteConfig.email}
                </a>
              </p>

              <p>
                <i className="ri-time-line"></i>
                <span>{siteConfig.hours}</span>
              </p>
            </div>

            {/* Newsletter */}
            <div style={{ marginTop: "2rem" }}>
              <h5 className="roha-footer__link-title">
                Newsletter
              </h5>

              <div className="roha-footer__note-list">
                <p>
                  Exclusive gemstone stories, new arrivals,
                  and private offers.
                </p>
              </div>

              <form
                className="newsletter"
                onSubmit={handleNewsletter}
              >
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  aria-label="Email address for newsletter"
                  required
                />

                <button
                  type="submit"
                  className="newsletter-btn"
                  aria-label="Subscribe"
                >
                  <i className="ri-send-plane-fill"></i>
                </button>
              </form>
            </div>
          </Col>
        </Row>

        {/* Divider */}
        <div className="roha-footer__divider" />

        {/* Bottom */}
        <div className="footer__bottom">
          <p className="section__description">
            <i className="ri-copyright-line"></i>
            {year} {siteConfig.name}. All rights reserved.
          </p>

          <div
            style={{
              display: "flex",
              gap: "1.5rem",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {legalLinks.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="footer-link-hover"
                style={{ fontSize: "0.78rem" }}
              >
                {item.display}
              </Link>
            ))}
          </div>

          <p className="section__description">
            Handcrafted in Addis Ababa · Bole Dembel City Center · Delivered Worldwide
          </p>

          <Link
            to="/generate-image"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.45rem",
              padding: "0.45rem 1rem",
              borderRadius: "999px",
              background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.06))",
              border: "1px solid rgba(201,168,76,0.28)",
              color: "var(--color-gold, #c9a84c)",
              fontSize: "0.78rem",
              fontWeight: 600,
              letterSpacing: "0.04em",
              textDecoration: "none",
              transition: "all 0.25s ease",
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "linear-gradient(135deg, rgba(201,168,76,0.22), rgba(201,168,76,0.1))"; e.currentTarget.style.borderColor = "rgba(201,168,76,0.5)"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.06))"; e.currentTarget.style.borderColor = "rgba(201,168,76,0.28)"; }}
          >
            <i className="ri-sparkling-2-line" style={{ fontSize: "0.9rem" }}></i>
            Powered by Roha Jewellery & Gemstone Collection
          </Link>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;